import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { LoginApiReturnData } from '@/types/auth';

type AuthState = {
  meInfo: LoginApiReturnData | null;
  token: string | null;
  refreshToken?: string | null;
  hydrated: boolean;
};

const initialState: AuthState = {
  meInfo: null,
  token: null,
  refreshToken: null,
  hydrated: false,
};

type CredentialsPayload = {
  meInfo: LoginApiReturnData;
  token: string | null;
  refreshToken?: string | null;
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    /** 登入成功後設定憑證 */
    setCredentials(state, action: PayloadAction<CredentialsPayload>) {
      const { meInfo, token, refreshToken } = action.payload;
      state.meInfo = meInfo;
      state.token = token;
      state.refreshToken = refreshToken ?? null;
    },

    /** 修改個人資料後，更新 meInfo（包含新頭像） */
    updateMeInfo(state, action: PayloadAction<Partial<LoginApiReturnData>>) {
      if (!state.meInfo) return;
      state.meInfo = { ...state.meInfo, ...action.payload };
    },

    logout(state) {
      state.meInfo = null;
      state.token = null;
      state.refreshToken = null;
    },

    /** 標記「已從 localStorage 嘗試讀取完」 */
    markHydrated(state) {
      state.hydrated = true;
    },
  },
});

export const { setCredentials, updateMeInfo, logout, markHydrated } = authSlice.actions;
export default authSlice.reducer;

// import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import type { LoginApiReturnData } from '@/types/auth';

// type AuthState = {
//   meInfo: LoginApiReturnData | null;
//   token: string | null;
//   refreshToken?: string | null;
//   hydrated?: boolean;
// };

// const initialState: AuthState = {
//   meInfo: null,
//   token: null,
//   refreshToken: null,
//   hydrated: false,
// };

// type CredentialsPayload = {
//   meInfo: LoginApiReturnData;
//   token: string | null;
//   refreshToken?: string | null;
// };

// const authSlice = createSlice({
//   name: 'auth',
//   initialState,
//   reducers: {
//     setCredentials(state, action: PayloadAction<CredentialsPayload>) {
//       const { meInfo, token, refreshToken } = action.payload;
//       state.meInfo = meInfo;
//       state.token = token;
//       state.refreshToken = refreshToken ?? null;
//     },

//     /** 修改個人資料後，更新 meInfo（包含新頭像） */
//     updateMeInfo(state, action: PayloadAction<Partial<LoginApiReturnData>>) {
//       if (!state.meInfo) return;

//       state.meInfo = { ...state.meInfo, ...action.payload };

//       try {
//         localStorage.setItem(
//           'meInfo',
//           JSON.stringify({
//             ...state.meInfo,
//             token: state.token,
//             refreshToken: state.refreshToken ?? null,
//           })
//         );
//       } catch (e) {
//         console.warn('Failed to write meInfo to localStorage', e);
//       }
//     },

//     logout(state) {
//       state.meInfo = null;
//       state.token = null;
//       state.refreshToken = null;
//       try {
//         localStorage.removeItem('meInfo');
//       } catch (e) {
//         console.warn('Failed to clear localStorage', e);
//       }
//     },

//     // hydrate 相關就照你原本的
//     markHydrated(state) {
//       state.hydrated = true;
//     },
//     hydrateFromLocalStorage(state) {
//       if (typeof window === 'undefined') return;
//       const stored = localStorage.getItem('meInfo');
//       if (stored) {
//         try {
//           const parsed = JSON.parse(stored);
//           state.meInfo = parsed;
//           state.token = parsed.token ?? null;
//           state.refreshToken = parsed.refreshToken ?? null;
//         } catch (e) {
//           console.warn('Failed to parse meInfo from localStorage', e);
//         }
//       }
//       state.hydrated = true;
//     },
//   },
// });

// export const { setCredentials, updateMeInfo, logout, markHydrated } = authSlice.actions;
// export default authSlice.reducer;
